<template>
  <div>
    <Bridge-Map />
    <!-- <Analytic-Gauge /> -->
    <!-- <br> -->
    <b-row>
      <b-col lg="5">
        <Bridge-Graph />
      </b-col>
      <b-col lg="3">
        <Bridge-Static />
      </b-col>
      <b-col lg="4">
        <Bridge-Img />
      </b-col>
    </b-row>
    <br>
    <!-- <b-row>
      <b-col lg="4">
        <Bridge-EventLog />
      </b-col>
      <b-col lg="8">
        <Bridge-Table />
      </b-col>
    </b-row> -->
    <br>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import BridgeMap from '@/views/sensor/bridge/detail/BridgeMapDetail.vue'
// import AnalyticGauge from '@/views/sensor/bridge/detail/BridgeGauge.vue'
import BridgeGraph from '@/views/sensor/bridge/detail/BridgeGraph.vue'
import BridgeStatic from '@/views/sensor/bridge/detail/BridgeStatic2.vue'
import BridgeImg from '@/views/sensor/bridge/detail/BridgeImg.vue'
// import BridgeTable from '@/views/sensor/bridge/detail/BridgeTable.vue'
// import BridgeEventLog from '@/views/sensor/bridge/detail/BridgeEventLog.vue'
// import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    BridgeMap,
    // AnalyticGauge,
    BridgeGraph,
    BridgeStatic,
    BridgeImg,
    // BridgeTable,
    // BridgeEventLog,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style>
</style>
